import { UserService } from '@common/lib/api';
import vueAuth from '@common/lib/auth';
import to from '@common/lib/common/to';
import * as user from './types';
import * as common from '@common/store/modules/common/types';
import { downloadFile } from '@common/lib/common/utils';
import * as shop from '@common/store/modules/shop/types';

const actions = {
  [user.FETCH_OWNER](context, data) {
    context.commit(user.SET_OWNER_PROFILE, data);
  },
  async [user.USER_RESET_STATE](context) {
    context.commit(user.USER_RESET_STATE);
  },
  async [user.FETCH_MAIN](context) {
    const { data } = await UserService.getMain();
    context.commit(user.SET_USER_MAIN, data);

    return data;
  },
  //admin애서
  async [user.FETCH_USER](context, params) {
    context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.getProfile(params);
    context.commit(user.SET_USER, data);
    context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },
  async [user.FETCH_ME](context) {
    const { data } = await UserService.getMyProfile();
    context.commit(user.SET_USER, data);

    return data;
  },
  async [user.USER_UPDATE](context, payload) {
    context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.update(payload);
    context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },
  async [user.USER_UPDATE_ME](context, payload) {
    await context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.modifyMyProfile(payload);
    await context.dispatch(user.FETCH_ME);
    await context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },
  async [user.RESET_PASSWORD_UPDATED_AT](context) {
    context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.resetPasswordUpdatedAt();
    context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },

  async [user.USER_PUBLISH](context, payload) {
    context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    payload.passwordConfirm = payload.password;
    const { data } = await UserService.publish(payload);
    context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },
  async [user.USER_DELETE](context, id) {
    context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.remove({
      id,
    });
    context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },
  async [user.USER_DELETE_ME](context) {
    context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await vueAuth.withdraw();
    context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },
  async [user.UPDATE_PASSWORD](context, params) {
    context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.modifyPassword(params);
    context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },
  async [user.UPDATE_PASSWORD_ME](context, params) {
    context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.updatePasswordMe(params);
    context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },
  //안쓴다.
  async [user.UPDATE_USER_DEVICE_INFO](context, params) {
    //const { data } = await UserService.pushToken(params);
    /*let [err, res] = await UserService.pushToken(params).then(
      v => [null, v],
      err => [err, null],
    );
    console.log(err, res);*/
    /*const { data } = await UserService.pushToken(params).catch(err => {
      console.log(err);
    });*/
    /*const [err, res] = await to(UserService.pushToken(params));
    if (err) {
      const msg = '토큰정보가 잘못되었습니다.';
      context.dispatch(
        common.ROOT_SET_SNACKBAR,
        {
          color: false,
          message: msg,
        },
        {
          root: true,
        },
      );
    }*/
    if (!params) {
      params = {
        notificationToken:
          context.rootState.common.appInfo.fbToken ||
          window.$bridge.deviceInfo.registrationKey ||
          '',
        deviceAppType:
          context.rootState.common.appInfo.appType ||
          window.$bridge.deviceInfo.appType ||
          '',
      };
    }
    if (!params.notificationToken) {
      return false;
    }
    //const { data } = await UserService.updateDeviceInfo(params);
    const { data } = await UserService.saveDeviceInfo(params);
    return data;
  },
  async [user.DELETE_USER_DEVICE_INFO](context, params) {
    if (!params) {
      params = {
        notificationToken:
          context.rootState.common.appInfo.fbToken ||
          window.$bridge.deviceInfo.registrationKey ||
          '',
        deciceAppType: window.$bridge.deviceInfo.appType,
      };
    }
    if (!params.notificationToken) {
      return false;
    }
    //const { data } = await UserService.deleteDeviceInfo(params);
    const { data } = await UserService.removeDeviceInfo(params);
    return data;
  },
  async [user.UPDATE_NOTIFICATION](context, params) {
    context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const [err, res] = await to(UserService.updateMe(params));
    context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });
    return res;
  },
  async [user.FIND_USER_ID](context, params) {
    const [err, res] = await to(UserService.findUserId(params));
    if (!err) {
      context.dispatch(
        common.ROOT_SET_DIALOG,
        {
          type: 'normal',
          icon: 'warning',
          //title: this.$t('user.find.id'),
          title: '아이디 찾기',
          message: res.data.message,
        },
        {
          root: true,
        },
      );
    }
    return res;
  },
  async [user.FIND_PASSWORD](context, params) {
    const [err, res] = await to(UserService.findUserPassword(params));
    if (!err) {
      context.dispatch(
        common.ROOT_SET_DIALOG,
        {
          type: 'normal',
          icon: 'warning',
          //title: this.$t('user.find.id'),
          title: '비밀번호 찾기',
          message: res.data.message,
        },
        {
          root: true,
        },
      );
    }
    return res;
  },
  async [user.FIND_USER_BY_MOBILE_NUMBER](context, mobileNumber) {
    const params = {
      mobileNumber: mobileNumber,
    };
    return await UserService.FindUserByMobileNumber(params);
  },
  async [user.FIND_USER_BY_USER_ID](context, userId) {
    const params = {
      userId,
    };
    return await UserService.FindUserByUserId(params);
  },
  async [user.EXIST_EMAIL](context, email) {
    const params = {
      email: email,
    };
    return await UserService.checkExistEmail(params);
  },
  async [user.EXIST_NICKNAME](context, nickname) {
    const params = {
      nickname: nickname,
    };
    return await UserService.checkExistNickname(params);
  },
  async [user.UPDATE_MOBILE_NUMBER_ME](context, params) {
    context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.changePhoneNumber(params);
    context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },
  async [user.UPDATE_EMAIL_ME](context, email) {
    context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.changeEmail(email);
    context.commit(user.SET_USER_EMAIL, email);
    context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },

  async [user.OWNER_UPDATE_ME](context, payload) {
    await context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.modifyOwnerProfile(payload);
    await context.dispatch(user.FETCH_ME);
    await context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },

  async [user.OWNER_SYNC_ME](context, payload) {
    await context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.syncOwnerProfileMe(payload);
    await context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },

  async [user.OWNER_SYNC](context, payload) {
    await context.dispatch(common.ROOT_SHOW_LOADING, null, {
      root: true,
    });
    const { data } = await UserService.syncOwnerProfile(payload);
    await context.dispatch(common.ROOT_HIDE_LOADING, null, {
      root: true,
    });

    return data;
  },

  async [user.UPDATE_AREA_ME](context, param) {
    const { areaId, areaName, codeType } = param;
    const payload = new FormData();
    payload.append('areaId', areaId);
    payload.append('codeType', codeType);
    const { data } = await UserService.setArea(payload);
    //history 저장
    context.commit(user.SET_AREA_HISTORY, param);
    await context.dispatch(user.FETCH_ME);
    return data;
  },

  async [user.UPDATE_USER_DATA](context, param) {
    const { areaId, areaName, codeType } = param.areaInfo;
    const payload = new FormData();
    payload.append('areaId', areaId);
    payload.append('codeType', codeType);
    payload.append('ageRange', param.ageRange);
    payload.append('gender', param.gender);

    const { data } = await UserService.setUserData(payload);
    //history 저장
    context.commit(user.SET_AREA_HISTORY, param.areaInfo);
    await context.dispatch(user.FETCH_ME);
    return data;
  },

  async [user.FETCH_USERS](context, param) {
    const { data } = await UserService.findUser(param);
    await context.commit(user.SET_USERS, data);
    return data;
  },
  async [user.FETCH_OWNERS](context, param) {
    const { data } = await UserService.findOwnerUser(param);
    await context.commit(user.SET_OWNERS, data);
    return data;
  },
  async [user.EXCEL_DOWNLOAD_USERS](context, param) {
    const response = await UserService.downloadUserExcel(param);
    downloadFile(response);
  },
  async [user.EXCEL_DOWNLOAD_OWNERS](context, param) {
    const response = await UserService.downloadOwnerExcel(param);
    downloadFile(response);
  },

  async [user.UPDATE_SCREEN_ACTIVED](context, param) {
    const { data } = await UserService.modifyScreenActived(param);

    return data;
  },
  async [user.UPDATE_CURRENT_AREA](context, param) {
    const { data } = await UserService.updateCurrentArea(param);
    return data;
  },
  async [user.FETCH_AUTH_AREA_ME](context) {
    const { data } = await UserService.getAuthAreaMe();
    context.commit(user.SET_AUTH_AREA, data);

    return data;
  },
  async [user.FETCH_AUTH_AREA](context, param) {
    const { data } = await UserService.getAuthArea(param);
    context.commit(user.SET_AUTH_AREA, data);

    return data;
  },
  // 사용자 현재 위치
  async [user.FETCH_USER_CURRENT_AREA](context, param) {
    const { data } = await UserService.getUserCurrentArea(param);
    return data;
  },
  // 사용자 현재 위치 저장
  async [user.SET_USER_CURRENT_AREA](context, params) {
    const { data } = await UserService.setUserCurrentArea(params);
    return data;
  },
  // 사용자 이용건수 ( 최근접속시간, 채팅수, 관심매장등록수, 리뷰수 )
  async [user.FETCH_USER_STATUS](context, param) {
    console.log(param);
    const { data } = await UserService.getUserStatus(param);
    context.commit(user.SET_USER_STATUS, data);

    return data;
  },
  // 사용자 디바이스 정보 업데이트( 통신사, 핸드폰 모델명 ) - 사용안함 20230829
  async [user.UPDATE_USER_TELECOM_DEVICE](context, param) {
    const { data } = await UserService.updateUserTelecomDevice(param);
    return data;
  },
  // 사용자 디바이스 정보 업데이트( 통신사, 핸드폰 모델명 (SM-910S) ) return 상품명: 갤럭시 S23+
  async [user.UPDATE_USER_TELECOM_AND_DEVICE](context, param) {
    console.log('telecomDevice2');
    const { data } = await UserService.updateUserTelecomAndDevice(param);
    return data;
  },

  async [user.FETCH_USER_DEVICE](context, param) {
    const { data } = await UserService.getUserDevice(param);
    return data;
  },
  async [user.COUNSEL_UPDATE](context, params) {
    const { data } = await UserService.setCounsel(params);
    return data;
  },
  async [user.SELECT_USER_INFO](context, params) {
    const { data } = await UserService.getUserInfo(params);
    // context.commit(user.SET_USER, data);
    // context.dispatch(common.ROOT_HIDE_LOADING, null, {
    //   root: true,
    // });

    return data;
  },
  async [user.UPDATE_NICKNAME](context, params) {
    const { data } = await UserService.updateUserNickname(params);
    await context.dispatch(user.FETCH_ME);
    return data;
  },
  async [user.FETCH_VIOLATION_ME](context, params) {
    const { data } = await UserService.getUserViolation();
    return data;
  },
  async [user.USER_REPORT](context, params) {
    console.log('paramsparamsparams');
    console.log(params);
    const { data } = await UserService.setUserReport(params);
    return data;
  },
};

export default actions;
